import gql from "graphql-tag";

export const USER_LOGIN = gql`
  mutation LoginUser(
    $mutationId: String!
    $username: String!
    $password: String!
  ) {
    login(
      input: {
        clientMutationId: $mutationId
        username: $username
        password: $password
      }
    ) {
      user {
        username
        userDetails {
          logins
          timeActive
        }
        name
      }
      authToken
    }
  }
`;

export const TRACK_ACTIVITY = gql`
  mutation TrackActivity(
    $mutationId: String!
    $action: String!
    $actionDate: String!
    $actionValue: String!
  ) {
    trackActivity(
      input: {
        clientMutationId: $mutationId
        action: $action
        actionDate: $actionDate
        actionValue: $actionValue
      }
    ) {
      user {
        username
        userDetails {
          activity {
            action
            actionDate
            actionValue
          }
        }
        name
      }
    }
  }
`;

export const VIDEO_LIST_QUERY = gql`
  query VideoQuery($cursor: String!, $section: String) {
    videos(
      after: $cursor
      where: {
        metaQuery: {
          metaArray: [
            { compare: LIKE, value: $section, key: "video_availability" }
          ]
        }
        orderby: { field: DATE, order: DESC }
      }
    ) {
      nodes {
        videoId
        title
        sections {
          nodes {
            name
            sectionId
            sortOrder
          }
        }
        videoSettings {
          videoUrl
        }
        mediaDetails {
          videoThumbnail {
            sourceUrl(size: MEDIUM)
          }
        }
        audioSettings {
          audio {
            mediaItemUrl
          }
        }
      }
      pageInfo {
        endCursor
      }
    }
  }
`;

export const SINGLE_VIDEO_QUERY = gql`
  query SelectedVideo($videoId: Int!) {
    videoBy(videoId: $videoId) {
      title
      content(format: RENDERED)
      videoSettings {
        videoUrl
      }
      mediaDetails {
        videoThumbnail {
          sourceUrl(size: MEDIUM)
        }
      }
    }
  }
`;

export const GET_TUTORIAL_VIDEO = gql`
  query TutorialVideo($type: String!) {
    categoryList: sections(where: { slug: "getting-started" }) {
      nodes {
        name
        videos(
          where: {
            metaQuery: {
              metaArray: [
                { compare: LIKE, key: "video_availability", value: $type }
              ]
            }
          }
        ) {
          nodes {
            videoId
          }
        }
      }
    }
  }
`;
